import { render, staticRenderFns } from "./hubHome.vue?vue&type=template&id=498342c6&"
import script from "./hubHome.vue?vue&type=script&lang=ts&"
export * from "./hubHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports